import type { TCountry } from "@app/dashboard/types/outerLayout/common";
import { COUNTRIES } from '@app/dashboard/constants/countries';
import { getLeadsServerUrl } from "@app/dashboard/utils/serverUrls";
import { getCapHeadersConfig } from "@app/dashboard/utils/capToken";
import { getFromLocalStorage } from "@app/dashboard/utils/manageLocalStorage";
import { LOCAL_STORAGE_KEYS } from "@app/dashboard/constants/local-storage-keys";
import { getCountryFromDomain } from "@app/dashboard/utils/getCountryFromDomain";
import { axiosPublic } from "@app/dashboard/tools/axios/axiosInstance";

const { FLASH_REDIRECT, SIGNUP_BY_PHONE_TOKEN } = LOCAL_STORAGE_KEYS;
const leadsServerUrl = getLeadsServerUrl();
const flashRedirect = getFromLocalStorage(FLASH_REDIRECT);

const shouldFlashRedirect = flashRedirect === true;
const country: TCountry = getCountryFromDomain();


export const registerSubmitPhone = async (phoneNumber: string, country: string, countryCode: string) => {

  const searchParams = window.location.search;

  const reqBody = {
    "phone_number": phoneNumber,
    "country_code": country,
    "phone_country_code": countryCode,
    "dashboard": true,
    ...(shouldFlashRedirect ? { "flash": true } : {})
  };

  return axiosPublic.post(
    `/dashboard/api/v1/register/submit-phone/${searchParams}`,
    reqBody,
    await getCapHeadersConfig()
  );
};

export const register = async (
  { firstName, lastName, email, businessName, preferredLanguage, city, businessType, products, password }
    :
    {
      firstName: string, lastName: string, email: string, businessName: string, preferredLanguage: string,
      city?: string, businessType?: string, products?: string, password: string
    }
) => {
  const signupPhoneToken = await getFromLocalStorage(SIGNUP_BY_PHONE_TOKEN);

  const reqBody = {
    "first_name": firstName,
    "last_name": lastName,
    "company_name": businessName,
    "preferred_language": preferredLanguage,
    ...(country === COUNTRIES.PAK ?
      {
        "city": city,
        "business_type": businessType,
        "payment_link": products?.includes("payment_link"),
        "pos": products?.includes("pos"),
        "payment_gateway": products?.includes("payment_gateway"),
      }
      :
      {}
    ),
    "email": email ? email : undefined,
    "password": password,
    "token": signupPhoneToken,
    ...(shouldFlashRedirect ? { "flash": true } : {})
  };

  return axiosPublic.post(`/dashboard/api/v1/register/complete/`, reqBody);
};

export const leadsSubmitPhone = (phoneNumber: string, leadToken: string) => {

  const reqBody = {
    "phone_number": phoneNumber,
  };

  return axiosPublic.put(`${leadsServerUrl}/api/v1.0/leads_form/${leadToken}/request_otp/`, reqBody);
};

export const leadsRegister = async (password: string, leadToken: string) => {
  const reqBody = {
    "password": password
  };

  return axiosPublic.post(`${leadsServerUrl}/api/v1.0/leads_form/${leadToken}/create_merchant/`, reqBody);
};

export const registerVerifyOtp = async (otp: string) => {
  const signupPhoneToken = await getFromLocalStorage(SIGNUP_BY_PHONE_TOKEN);

  const reqBody = {
    "otp": otp,
    "token": signupPhoneToken,
  };

  return axiosPublic.post(`/dashboard/api/v1/register/otp-verify/`, reqBody);
};

export const leadsRegisterVerifyOtp = (otp: string, leadToken: string) => {

  const reqBody = {
    "otp": otp
  };

  return axiosPublic.put(`${leadsServerUrl}/api/v1.0/leads_form/${leadToken}/validate_otp/`, reqBody);
};

export const registerResendOtp = async (requestedFor: "register" | "forget-password" = "register") => {
  const signupPhoneToken = await getFromLocalStorage(SIGNUP_BY_PHONE_TOKEN);

  const reqBody = {
    "token": signupPhoneToken,
  };

  const caseQueryParam = requestedFor === "forget-password" ? "reset" : "signup";

  return axiosPublic.post(`/dashboard/api/v1/${requestedFor}/otp-resend/?case=${caseQueryParam}`, reqBody);
};